import { render, staticRenderFns } from "./histogramCA.vue?vue&type=template&id=26d2d113&"
import script from "./histogramCA.vue?vue&type=script&lang=js&"
export * from "./histogramCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports